import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';
import { ScrubDiagnosticsExportResponse } from '../../models';

export const getAiScrubDiagnosticsExport: (
  fetchContext: FetchContext,
  awardId: number,
  batchRunId: string,
  accessToken?: string,
) => Promise<ScrubDiagnosticsExportResponse> = (fetchContext, awardId, batchRunId, accessToken) =>
  fetch(`${fetchContext.baseUrl}/api/staff/awards/${awardId}/ai-scrub-batch/${encodeURIComponent(batchRunId)}/diagnostics-export`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  })
  .then((response) => responseErrorHandler<ScrubDiagnosticsExportResponse>(fetchContext.errorStore, response, 'export AI scrub diagnostics'));
